import controller from './dropdown.controller';
import template from './dropdown.html';
/**
 * @ngdoc component
 * @name dropdown
 * @description
 * The dropdown component of the app.
 *
 * @memberof common
 */
export default {
  /**
   * The controller class for the component.
   * @type {DropdownController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} placeholder       The dropdown placeholder.
   * @property {String} errorMessage      The dropdown error Message.
   * @property {Array} items              The dropdown items to select from.
   * @property {Object} selectedItem      The initial selected item.
   * @property {Boolean} inError          The dropdown error state.
   * @property {Boolean} disabled         The dropdown disabled state.
   * @property {Function} onItemSelected  The callback when the item changes.
   */
  bindings: {
    placeholder: '@',
    errorMessage: '@',
    items: '<',
    selectedItem: '<',
    inError: '<',
    disabled: '<',
    onItemSelected: '&',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/common/components/dropdown/dropdown.component.js